<template>
    <div class="">
        <transition name="flow-object-active-node-trans" mode="out-in">
            <div v-if="localActive" class="">
                <slot>
                    Custom Tab: {{ name }}
                </slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'FlowObjectCustomTab',
    components: {},
    mixins: [],
    props: {
        name: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            isFlowObjectCustomTab: true,  // used to inspect from parents
            localActive: this.active,  // start with initial value as prop value, then parent updates it!
        }
    },
}
</script>

<style>

</style>